import types from 'actions/types'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {combineReducers} from 'redux'
import {getFilterFromAction} from 'helpers/reducer'

export const contactsContextQuotesTabPivotTableKey = 'contactsContext.selected.quotesTab.pivotTable'

const showCompleted = (state = false, action) => {
  switch (action.type) {
    case types.CONTACTS_QUOTES_UPDATE_FILTERS:
      return getFilterFromAction(state, action, 'showCompleted')
    default:
      return state
  }
}

const showInactive = (state = false, action) => {
  switch (action.type) {
    case types.CONTACTS_QUOTES_UPDATE_FILTERS:
      return getFilterFromAction(state, action, 'showInactive')
    default:
      return state
  }
}

const showAllRevisions = (state = false, action) => {
  switch (action.type) {
    case types.CONTACTS_QUOTES_UPDATE_FILTERS:
      return getFilterFromAction(state, action, 'showAllRevisions')
    default:
      return state
  }
}

export default combineReducers({
  showCompleted,
  showInactive,
  showAllRevisions,
  pivotTable: createPivotTableReducer({key: contactsContextQuotesTabPivotTableKey, defaultSortColumn: 'expectedDate', defaultSortDirection: 'desc'}),
})
